import { Record } from '@/domains/work';
import { Load } from '@/domains/system';
import { export_json_to_excel } from '@/vendor/Export2Excel';
import TemplatesExcelUtil from '@/utils/excel/template/TemplateExcelUtil';

/**
 * 理论课档案Excel3
 */
export default class TheoryTemplateExcelUtil2 extends TemplatesExcelUtil {
  /**
   * 导出理论课3Excel
   *
   * @param datas 听课档案列表
   */
  public static endHeader3: string[] = [
    '开课学科',
    '“是”的理由',
    '如“不确定”或“无必要”，请填写具体原因或表现',
    '如“不确定”或“未达到”，请填写具体原因或表现',
    '如“是”，请填写具体原因或表现',
    '如“是”，请填写具体原因或表现',
    '督导员所从事专业',
    '听课类型',
    '学年学期',
    '督导学科',
    '督导所属学院',
    '教师姓名状态',
    '补充课程名称',
  ];

  public static exportExcel(datas: Record[]) {
    Load.startFullLoad('正在导出理论课3档案');

    // 档案标题头
    let headers: string[] = [];
    // 档案标题头（格式化）
    const formatHeaders: string[] = [];

    // Excel数据列表
    const excelList: any[] = this.toExccelData(datas, headers);
    headers = headers.concat(this.endHeader3);
    // Excel数据列表（格式化）
    const formatData: any[] = this.format(excelList, headers, formatHeaders);

    for (let i = 0; i < formatData.length; i++) {
      for (let j = 0; j < formatData[i].length; j++) {
        if (formatData[i][j] === undefined || formatData[i][j] === null) {
          formatData[i][j] = '';
        }
      }
    }

    for (let i = 0; i < formatData.length; i++) {
      const record = datas[i];
      const data = formatData[i];

      try {
        data[45] = record.plan.coursePlan.clazz.department.courseGroup.name;
      } finally {
      }
      try {
        data[26] = record.template.questions[6].answer.other;
      } finally {
      }
      try {
        data[28] = record.template.questions[7].answer.other;
      } finally {
      }
      try {
        data[30] = record.template.questions[8].answer.other;
      } finally {
      }
      try {
        data[32] = record.template.questions[9].answer.other;
      } finally {
      }
      try {
        data[34] = record.template.questions[10].answer.other;
      } finally {
      }
      try {
        data[39] = record.plan.supervisor.supervisorGroup.courseGroup.name;
      } finally {
      }
      try {
        data[40] = record.plan.supervisor.person.department.name;
      } finally {
      }
      try {
        data[41] = '';
      } finally {
      }
      try {
        data[44] = record.plan.listenTypeName;
      } finally {
      }
      try {
        data[46] =
          record.plan.coursePlan.clazz.year.substr(0, 4) +
          '学年 第' +
          record.plan.coursePlan.clazz.term +
          '学期';
      } finally {
      }
      try {
        data[49] = (record as any).userStatusValue;
      } finally {
      }
      try {
        data[6] = record.template.questions[1].questions[11].answer.answer;
      } finally {
      }
    }

    export_json_to_excel({
      header: formatHeaders,
      data: formatData,
      filename: '听课档案列表(201910)' + new Date().getTime(),
      autoWidth: true,
    });
  }

  /**
   * 格式化
   *
   * @param datas Excel数据列表
   * @param headers Excel表头列表
   * @param formatHeaders Excel表头列表（格式化）
   */
  private static format(datas: any[], headers: string[], formatHeaders: string[]) {
    const order = [
      0,
      38,
      -1,
      -1,
      1,
      2,
      3,
      4,
      8,
      5,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      -1,
      20,
      21,
      22,
      23,
      25,
      27,
      29,
      31,
      33,
      35,
      36,
      24,
      -1,
      37,
      47,
      -1,
      7,
      42,
      43,
      48,
      -1,
      -1,
      -1,
      -1,
      -1,
      -1,
      50,
      45,
      26,
      28,
      30,
      32,
      34,
      41,
      44,
      46,
      39,
      40,
      49,
      6,
    ];

    const list: string[][] = [];

    let i = 0;
    headers.forEach((header) => {
      if (order[i] !== -1) {
        formatHeaders[order[i]] = header;
      }
      i++;
    });

    i = 0;
    datas.forEach((subs: string[]) => {
      let j = 0;
      const temp: string[] = [];
      subs.forEach((data: string) => {
        if (order[j] !== -1) {
          temp[order[j]] = data;
        }
        j++;
      });
      list.push(temp);
      i++;
    });
    return list;
  }
}
